import * as actions from "./actions.js";
import * as api from "./api.js";
import * as sagas from "./sagas.js";
import * as mixed from "./mixed.js";

const UPCOMING_WEBINARS = "UPCOMING_WEBINARS";
const CURRENT_WEBINARS = "CURRENT_WEBINARS";
const PREVIOUS_WEBINARS = "PREVIOUS_WEBINARS";
const RECORDED_WEBINARS = "RECORDED_WEBINARS";
const LANDING_WEBINARS = "LANDING_WEBINARS";
const LIVE_WEBINARS = "LIVE_WEBINARS";
const MODAL_TYPE_QUIZ = "MODAL_TYPE_QUIZ";
const MODAL_TYPE_NAVBAR = "MODAL_TYPE_NAVBAR";
const MODAL_TYPE_DASHBOARD = "MODAL_TYPE_DASHBOARD";
const MODAL_TYPE_WEBINAR = "MODAL_TYPE_WEBINAR";
const MODAL_TYPE_DELETE_CONFIRMATION = "MODAL_TYPE_DELETE_CONFIRMATION";
const MODAL_TYPE_USER_LEAVE_GROUP = "MODAL_TYPE_USER_LEAVE_GROUP";
const UPCOMING_CLIENT_WEBINARS = 'upcoming';
const CURRENT_CLIENT_WEBINARS = 'current';
const PREVIOUS_CLIENT_WEBINARS = 'previous';

const MODAL_ADD_TO_CALENDAR = "MODAL_ADD_TO_CALENDAR";

const MODAL_TYPE_STATS = "MODAL_TYPE_STATS";
const MODAL_TYPE_COURSE_MATERIAL = "MODAL_TYPE_COURSE_MATERIAL";
const STATISTIC_TYPE = {
  VIEWED: "viewed",
  ATTENDED: "attended",
};
const ROLES = {
  gp: "GP",
  gp_trainee: "GP Trainee",
  nurse: "Nurse",
  consultant: "Consultant",
  hospital_doctor: "NCHD (Hospital Doctor)",
  nurse_specialist: "Nurse Specialist/ANP",
  allied_healthcare_professional: "Allied Healthcare Professional",
  sponsor: "Sponsor",
  pharmacist: "Pharmacy",
};
const PRIVATE_HOSPITALS_FILER = [
  {
    label: "First Name",
    value: "first_name",
  },
  {
    label: "Last Name",
    value: "last_name",
  },
  {
    label: "Gender",
    value: "gender",
  },
  {
    label: "Age",
    value: "age",
  },
  {
    label: "International/Irish",
    value: "accreditation",
  },
  {
    label: "User Type",
    value: "user_type",
  },
  {
    label: "Hospital",
    value: "hospital",
  },
  {
    label: "Disciplines",
    value: "disciplines",
  },
];
const PHARMACEUTICAL_SPONSORS_FILER = [
  {
    label: "Gender",
    value: "gender",
  },
  {
    label: "Age",
    value: "age",
  },
  {
    label: "International/Irish",
    value: "accreditation",
  },
  {
    label: "User Type",
    value: "user_type",
  },
  {
    label: "Hospital",
    value: "hospital",
  },
  {
    label: "Disciplines",
    value: "disciplines",
  },
];
const CHART_COLORS = ["#2d98de", "#66b4e7", "#427799", "#b0c7d6"];

const indexConstants = {
  UPCOMING_WEBINARS,
  CURRENT_WEBINARS,
  LIVE_WEBINARS,
  RECORDED_WEBINARS,
  PREVIOUS_WEBINARS,
  MODAL_TYPE_QUIZ,
  MODAL_TYPE_NAVBAR,
  MODAL_TYPE_DASHBOARD,
  MODAL_TYPE_WEBINAR,
  MODAL_TYPE_DELETE_CONFIRMATION,
  MODAL_TYPE_STATS,
  MODAL_TYPE_COURSE_MATERIAL,
  LANDING_WEBINARS,
  STATISTIC_TYPE,
  ROLES,
  PRIVATE_HOSPITALS_FILER,
  PHARMACEUTICAL_SPONSORS_FILER,
  CHART_COLORS,
  MODAL_TYPE_USER_LEAVE_GROUP,
  MODAL_ADD_TO_CALENDAR,
  UPCOMING_CLIENT_WEBINARS,
  CURRENT_CLIENT_WEBINARS,
  PREVIOUS_CLIENT_WEBINARS,
};

const globalConstants = {
  ...indexConstants,
  ...actions,
  ...api,
  ...sagas,
  ...mixed,
};
export default globalConstants;



// WEBPACK FOOTER //
// ./src/constants/index.js